// Shown in tooltips on disabled management controls (create/edit/apply/export)
// so members understand why the action is unavailable. Mirrors the backend
// 403 copy in chart-of-accounts-template-guard.service.ts.
export const COA_TEMPLATE_MANAGE_FORBIDDEN_TOOLTIP =
    "You don't have permission to manage templates. Contact your organization Admin to request access.";

export const COA_TEMPLATE_ARCHIVE_FORBIDDEN_TOOLTIP =
    "You don't have permission to archive or enable this template.";

export const COA_TEMPLATE_DELETE_FORBIDDEN_TOOLTIP =
    "You don't have permission to delete this template.";
